import { render } from "./ActorDetailView.vue?vue&type=template&id=0abe46d6"
import script from "./ActorDetailView.vue?vue&type=script&lang=js"
export * from "./ActorDetailView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__